import { render } from "./PrintCards.vue?vue&type=template&id=3d170152&scoped=true"
import script from "./PrintCards.vue?vue&type=script&lang=js"
export * from "./PrintCards.vue?vue&type=script&lang=js"

import "./PrintCards.vue?vue&type=style&index=0&id=3d170152&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d170152"]])

export default __exports__